import { useMemo } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

import { isNativeCurrentBoardInfoEnabled } from './isNativeCurrentBoardInfoEnabled';

const featureGateName = 'trello_native_graphql_migration_milestone_1';
const defaultGateValue = false;

/**
 * Custom hook to check if the feature gate `'trello_native_graphql_migration_milestone_1'`
 * and its prerequisites are enabled.
 * @returns true if the feature gate is enabled, false otherwise.
 */
export const useNativeGraphqlMigrationMilestone1 = () => {
  const quickloadFlagEnabled = isNativeCurrentBoardInfoEnabled();
  const subscriptionsGateEnabled = useFeatureGate('gql_client_subscriptions');
  const milestoneGateEnabled = useFeatureGate(featureGateName);

  return useMemo(
    () =>
      (quickloadFlagEnabled &&
        subscriptionsGateEnabled.value &&
        milestoneGateEnabled.value) ??
      defaultGateValue,
    [
      quickloadFlagEnabled,
      subscriptionsGateEnabled.value,
      milestoneGateEnabled.value,
    ],
  );
};
